import { createTextEditorStore } from '@lessonup/pin-renderer';

export const teacherTextEditorStore = createTextEditorStore();
